import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createUnknownComponentVNode as _$cc, createVNode as _$cv, className as _$cn, noop as _$no } from 'intact-vue';
import { Icon } from '../icon';
import { getRestProps } from '../utils';
import { makeStyles } from './styles';
import { Transition } from 'intact-vue';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    className = _this$get.className,
    children = _this$get.children,
    type = _this$get.type,
    border = _this$get.border,
    disabled = _this$get.disabled,
    closable = _this$get.closable,
    closed = _this$get.closed,
    size = _this$get.size;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-tag"] = !$props.className, _classNameObj[className] = className, _classNameObj[k + "-" + type] = type !== 'default', _classNameObj[k + "-" + size] = size !== 'default', _classNameObj[k + "-" + border] = border, _classNameObj[k + "-disabled"] = disabled, _classNameObj[k + "-closable"] = closable, _classNameObj[makeStyles(k)] = true, _classNameObj[$props.className] = $props.className, _classNameObj);
  return _$cc(Transition, {
    'name': $props.name || k + "-scale",
    'children': !closed ? _$cv('div', _extends({
      'className': _$cn(classNameObj)
    }, getRestProps(this)), [(_$blocks['body'] = function ($super) {
      return children;
    }, __$blocks['body'] = function ($super, data) {
      var block = $blocks['body'];
      var callBlock = function callBlock() {
        return _$blocks['body'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }, __$blocks['body'](_$no)), (_$blocks['_close'] = function ($super) {
      return closable ? _$cc(Icon, {
        'className': _$cn(k + "-tag-close ion-ios-close-empty"),
        'color': type,
        'hoverable': !disabled,
        'ev-click': this.onClose
      }) : undefined;
    }, __$blocks['_close'] = function ($super, data) {
      var block = $blocks['_close'];
      var callBlock = function callBlock() {
        return _$blocks['_close'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }, __$blocks['_close'](_$no))]) : undefined
  });
}
;